import React, { useState } from "react";
import GradientButton from "../../../../components/button/Button";
import axiosInstance from "../../../../axiosInstance";
import { toast } from "react-toastify";
import LoadingComponent from "../../../../components/loading/Loading";
import { Logo } from "../../../../images/Images";

const RetailRegister: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Payload:", formData);
    const payload = {
      full_name: formData.fullName,
      email: formData.email,
      phone_number: formData.phone,
      password: formData.password,
      confirm_password: formData.confirmPassword,
      type: "retailer",
    };

    try {
      setLoading(true);

      const res = await axiosInstance.post("/users", payload);

      if (res.data) {
        setLoading(false);
        toast.success(
          "User account created successfully. Please verify your email address."
        );
        localStorage.setItem("verify_id", res.data?.data?.id);
        setTimeout(() => {
          window.location.href = "/verify-email";
        }, 3000);
      }
    } catch (error: any) {
      setLoading(false);

      if (error?.response?.data) {
        const { message, errors } = error.response.data;

        // Show the general error message
        toast.error(message || "Error creating user account");

        // Show specific field errors (if any)
        if (errors) {
          Object.entries(errors).forEach(([field, errMsg]) => {
            toast.error(`${field}: ${errMsg}`);
          });
        }
      } else {
        toast.error("Error creating user account");
      }
    }
  };

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="login-page">
      <div className="login-page__image">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>
      <div className="login-page__form-container">
        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Create your Account</h2>
          <p className="login-page__description">
            Fill the form to get started
          </p>
          <div className="login-page__input-group">
            <label>Full Name </label>
            <input
              type="text"
              name="fullName"
              placeholder="E.g John Doe"
              required
              value={formData.fullName}
              onChange={handleChange}
            />
          </div>
          <div className="login-page__input-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="E.g JohnDoe@gmail.com"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="login-page__input-group">
            <label>Phone Number</label>
            <input
              type="text"
              name="phone"
              placeholder="E.g +234 6178 88221"
              required
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="login-page__input-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              required
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          <div className="login-page__input-group">
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Re-enter your password"
              required
              value={formData.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <div className="gd-btn">
            <GradientButton text="Create Account" />
          </div>
          <div className="login-page__signup">
            <p>
              Already have an account? <a href="/login">Log in</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RetailRegister;
